import HistoricBasicInformationSection from "../../../../features/bonds/shared/components/HistoricBasicInformationSection";
import { HISTORIC_BASIC_INFO_CONFIG } from "../../../../features/bonds/shared/historicBasicInformationConfig";

const BasicInformationForm = (props) => (
  <HistoricBasicInformationSection config={HISTORIC_BASIC_INFO_CONFIG.trustee} {...props} />
);

export default BasicInformationForm;
